<script lang="ts" setup>
  defineEmits([
    'selected',
  ]);

  defineProps({
    addresses: { type: Object, required: true },
    loading: { type: Boolean, default: false },
  });
</script>
<template>
  <SfDataLoader :loading="loading">
    <section class="shipping-address-picker">
      <SfTile
        v-for="address in addresses"
        :default="address.default"
        class="shipping-address-picker__option"
        interactive shadow small
        tabindex="0"
        @click="$emit('selected', address)"
        @keydown.space="$emit('selected', address)"
      >
        <template v-if="address.default" #outer>
          <span class="shipping-address-picker__address-default">{{ $t('Adres domyślny') }}</span>
        </template>
        <template #title>
          <h4 class="shipping-address-picker__address-heading">{{ address.name }}</h4>
        </template>
        <template #default>
          <address class="shipping-address-picker__address-content">
            <p v-if="address.company" class="shipping-address-picker__company">{{ address.company }}</p>
            <p v-if="address.first_line" class="shipping-address-picker__first-line">{{ address.first_line }}</p>
            <p v-if="address.second_line" class="shipping-address-picker__second-line">{{ address.second_line }}</p>
            <p v-if="address.third_line" class="shipping-address-picker__third-line">{{ address.third_line }}</p>
            <p v-if="address.email" class="shipping-address-picker__email">{{ address.email }}</p>
            <p v-if="address.phone" class="shipping-address-picker__phone">{{ address.phone }}</p>
          </address>
        </template>
      </SfTile>
    </section>
  </SfDataLoader>
</template>
<style lang="scss">
  @use "$assets/mixins/media";

  .shipping-address-picker {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    flex-grow: 1;

    &__option {
      position: relative;
      cursor: pointer;
    }

    &__address-content {
      font-style: normal;
      font-size: 0.875rem;
    }

    @include media.query(lg) {
      grid-template-columns: repeat(2, 1fr);
    }

    @include media.query(sm) {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
  }
</style>
